/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = 'inprogress';

/** State representing the case status of each cargo on the shipment page (inprogress / complete / dispute). */
const progressValueSlice = createSlice({
    name: 'progressValue',
    initialState: initialState,
    reducers: {
        setProgessValueData: (state, action) => {
            return action.payload;
        },
        resetProgressValueData: () => {
            return initialState;
        },
    },
});

export const { setProgessValueData, resetProgressValueData } = progressValueSlice.actions;
export default progressValueSlice.reducer;
